import React, { useState, useContext, useEffect, useRef } from 'react';
import { TemplateContext } from '../layout';
import CreditCards from './creditCards';

const Accordion = ({ children, label, image, name, overflow, maxImgWidth, imageHeight }) => {
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	const [expanded, setExpanded] = useState();
	const [componentMounting, setComponentMounting] = useState(true);
	const [overSetting, setOverflowSetting] = useState(false);
	const contentRef = useRef(null);

	useEffect(() => {
		if (overflow) {
			setTimeout(() => {
				if (overflow) {
					setOverflowSetting(true);
				}
			}, 600);
		} else {
			setOverflowSetting(false);
		}
	}, [overflow]);

	setTimeout(() => {
		setComponentMounting(false);
	}, 100);

	useEffect(() => {
		name == templateContext?.paymentMethod ? setExpanded(true) : setExpanded(false);
	}, [templateContext?.paymentMethod]);

	const handleAccordionClick = () => {
		setTemplateContext((prevContext) => {
			return {
				...prevContext,
				paymentMethod: name,
			};
		});
	};
	return (
		<>
			<div
				onClick={handleAccordionClick}
				expanded={expanded}
				className={
					expanded
						? 'accordionContainer__heading'
						: 'accordionContainer__heading accordionContainer__heading--unchecked'
				}
			>
				<button className="accordionContainer__button" type="button"></button>
				{label && <span className="cardRadio__labelText"> {label} </span>}
				{name == 'card' ? (
					<CreditCards />
				) : (
					<img
						className="cardRadio__image"
						src={image}
						alt="Payments"
						style={{
							maxWidth: `${maxImgWidth}px`,
							marginLeft: label ? 'auto' : 0,
							height: imageHeight && `${imageHeight}px`,
						}}
					/>
				)}
			</div>

			<section
				className="accordionContainer__wrapper"
				style={{
					transition: componentMounting && 'none',
					overflow: overSetting && 'visible',
					maxHeight: expanded ? `${contentRef?.current?.scrollHeight + 64}px` : 0,
				}}
				aria-expanded={expanded}
				ref={contentRef}
			>
				<div
					className={
						name == 'paypal'
							? 'accordionContainer__content accordionContainer__content--paypal'
							: 'accordionContainer__content'
					}
				>
					{children}
				</div>
			</section>
		</>
	);
};

export default Accordion;
